<script>
  import {getContext} from 'svelte';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');
</script>

<style>
  .wrap {
    background: white;
  }
  .main {
    margin: 0 auto;
    box-sizing: border-box;
    padding: 120px 0;
    width: 1200px;
  }
  .title {
    margin-top: 0;
    margin-bottom: 48px;
    text-align: center;
    font-size: 48px;
  }
  .content {
    border-radius: 20px;
  }
  .content > img {
    width: 50%;
  }
  .text {
    padding: 60px 68px;
    line-height: 32px;
    font-size: 20px;
    background: #f4f4f4;
  }

  @media screen and (max-width: 640px) {
    .main {
      padding: 40px 20px;
      width: 100%;
    }
    .title {
      margin-bottom: 24px;
      text-align: left;
      font-size: 18px;
    }
    .content {
      flex-flow: column-reverse;
    }
    .content > img {
      width: 100%;
    }
    .text {
      padding: 24px 20px;
      line-height: 20px;
      font-size: 14px;
    }
  }
</style>

<section class="wrap">
  <div class="main">
    <h2 class="title">{LG(lang.OurDuty)}</h2>
    <div class="content df ovh">
      <div class="text f1">
        <img class="db mb24" width="100%" src={IMAGES.DAUPHINE_UNIVERSITY} alt="dauphine university" />
        <div class="fw2">{LG(lang.OurDutyDesc)}</div>
      </div>
      <img class="dib" src={IMAGES.UNIVERSITY} alt="cryptocurrency" />
    </div>
  </div>
</section>
